import React, { type ReactNode, useState } from 'react'

import { Button, Division, Input, ModalBox } from '@fourthwall/components'

import * as S from './OrderEditConfimModal.styled'

type OrderEditConfirmModalProps = {
  content: ReactNode
  footer?: ReactNode
  close: () => void
  onConfirm: (reason?: string) => void
}

export const OrderEditConfirmModal = ({
  content,
  footer,
  close,
  onConfirm,
}: OrderEditConfirmModalProps) => {
  const [reason, setReason] = useState('')

  const handleConfirm = () => {
    close()

    return onConfirm(reason || undefined)
  }

  return (
    <ModalBox
      title="Are you sure you want to edit this order?"
      buttons={[
        <Button label="Cancel" appearance="secondary" onClick={close} />,
        <Button label="Update" appearance="primary" onClick={handleConfirm} />,
      ]}
      onClose={close}
    >
      {content}
      {footer && <Division size="small">{footer}</Division>}
      <S.InputContainer>
        <Input
          name="reason"
          value={reason}
          label="Edit reason (optional)"
          suggestion="Only you and other managers can see this reason"
          onValueChange={setReason}
        />
      </S.InputContainer>
    </ModalBox>
  )
}
